import { Accordion, Box, Paper, styled } from "@mui/material";

const StyledPaper = styled(Paper)(({ theme }) => ({
  borderRadius: '1.5rem',
  width: '100%',
  height: '100%',
  overflow: 'scroll',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  margin: theme.spacing(2),
  padding: theme.spacing(2), // Added padding to the container
}));

// New styled Accordion component
const StyledAccordion = styled(Accordion)(({ theme, expanded }) => ({
  borderRadius: '1rem !important', // Force border radius
  marginBottom: theme.spacing(2), // Add margin between accordions
  '&:before': {
    display: 'none', // Remove the default divider
  },
  '&:first-of-type': {
    borderRadius: '1rem',
  },
  '&:last-of-type': {
    marginBottom: 0,
    borderRadius: '1rem',
  },
  '&.Mui-expanded': {
    '& .MuiAccordionSummary-root': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiTypography-root': {
        color: 'white',
      },
      '& .MuiSvgIcon-root': { // This will make the expand icon white too
        color: 'white',
      },
    },
  },
}));

const VideoContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  padding: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 300,
  width: '100%',
  borderRadius: '0.75rem', // Added border radius to video container
}));

const ContentContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  flex: 1,
}));

export {
  StyledPaper,
  StyledAccordion,
  VideoContainer,
  ContentContainer
}